import type { SelectionMarkerPluginOptions } from '@atlaskit/editor-plugin-selection-marker';

interface Props {
	options: Pick<SelectionMarkerPluginOptions, 'hideCursorOnInit'> | undefined;
}

export function selectionMarkerPluginOptions({
	options,
}: Props): SelectionMarkerPluginOptions | undefined {
	return options
		? {
				hideCursorOnInit: options.hideCursorOnInit,
			}
		: undefined;
}
